var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdf-preview", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.inPreview,
            expression: "inPreview"
          }
        ],
        attrs: {
          inPreview: _vm.inPreview,
          generatingPreview: _vm.generatingPreview,
          saving: _vm.saving,
          pdfUrl: _vm.pdfUrl,
          backToForm: _vm.backToForm,
          save: _vm.save
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inPreview,
              expression: "!inPreview"
            }
          ]
        },
        [
          _c(
            "form",
            {
              attrs: {
                "data-vv-scope": "custom-document",
                autocomplete: "off"
              },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("h2", { staticClass: "mb-10" }, [_vm._v("Oficio")]),
              _c("div", { staticClass: "row form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-3 col-form-label",
                    attrs: { for: "sender" }
                  },
                  [_vm._v("De")]
                ),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.required("sender")) }
                }),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("list-user", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      ref: "sender",
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "",
                        "data-cy": "sender",
                        "data-vv-as": "DE",
                        name: "sender",
                        label: "",
                        placeholder: "Selecciona un usuario",
                        danger: _vm.errors.has("custom-document.sender"),
                        "danger-text": _vm.errors.first(
                          "custom-document.sender"
                        )
                      },
                      on: { "full-user": _vm.addUserData },
                      model: {
                        value: _vm.formData.sender,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "sender", $$v)
                        },
                        expression: "formData.sender"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-3 col-form-label",
                    attrs: { for: "senderPosition" }
                  },
                  [_vm._v("Cargo")]
                ),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.required("senderPosition"))
                  }
                }),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        "data-cy": "senderPosition",
                        "data-vv-as": "cargo",
                        name: "senderPosition",
                        type: "text",
                        state: _vm.errors.has("custom-document.senderPosition")
                          ? false
                          : null,
                        danger: _vm.errors.has(
                          "custom-document.senderPosition"
                        ),
                        "danger-text": _vm.errors.first(
                          "custom-document.senderPosition"
                        )
                      },
                      model: {
                        value: _vm.formData.senderPosition,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "senderPosition", $$v)
                        },
                        expression: "formData.senderPosition"
                      }
                    }),
                    _vm.errors.has("custom-document.senderPosition")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to",
                            staticStyle: { height: "19px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.senderPosition"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-3 col-form-label",
                    attrs: { for: "receiver" }
                  },
                  [_vm._v("A")]
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        state: _vm.errors.has("custom-document.receiver")
                          ? false
                          : null,
                        "data-cy": "receiver",
                        "data-vv-as": "A",
                        name: "receiver",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.receiver,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "receiver", $$v)
                        },
                        expression: "formData.receiver"
                      }
                    }),
                    _vm.errors.has("custom-document.receiver")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.receiver"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-3 col-form-label",
                    attrs: { for: "receiverPosition" }
                  },
                  [_vm._v("Cargo")]
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        "data-cy": "receiverPosition",
                        "data-vv-as": "cargo",
                        name: "receiverPosition",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.receiverPosition,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "receiverPosition", $$v)
                        },
                        expression: "formData.receiverPosition"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-3 col-form-label",
                    attrs: { for: "receiverPosition" }
                  },
                  [_vm._v("Empresa o municipio")]
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        "data-cy": "receiverCompany",
                        "data-vv-as": "empresa o municipio",
                        name: "receiverCompany",
                        type: "text"
                      },
                      model: {
                        value: _vm.formData.receiverCompany,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "receiverCompany", $$v)
                        },
                        expression: "formData.receiverCompany"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-3 col-form-label",
                    attrs: { for: "date" }
                  },
                  [_vm._v("Fecha")]
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("date-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "w-100": true,
                            danger: _vm.$validator.errors.has("date")
                          },
                          attrs: {
                            "data-cy": "date",
                            name: "date",
                            "data-vv-as": "fecha",
                            format: "DD-MM-YYYY",
                            "value-type": "DD-MM-YYYY",
                            placeholder: "Ej: 30-12-2000",
                            disabled: "",
                            danger: _vm.$validator.errors.has("date")
                          },
                          model: {
                            value: _vm.formData.date,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "date", $$v)
                            },
                            expression: "formData.date"
                          }
                        }),
                        _vm.$validator.errors.has("date")
                          ? _c("v-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$validator.errors.first("date")) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Ant:" } },
                      [
                        _c("editor-text", {
                          ref: "background",
                          attrs: {
                            "data-cy": "background",
                            name: "background",
                            "max-length": 500,
                            "toolbar-items": {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.background,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "background", $$v)
                            },
                            expression: "formData.background"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Materia *" } },
                      [
                        _c("editor-text", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "matter",
                          attrs: {
                            danger: _vm.errors.has("custom-document.matter"),
                            "danger-text": _vm.errors.first(
                              "custom-document.matter"
                            ),
                            "data-cy": "matter",
                            "data-vv-as": "materia",
                            name: "matter",
                            "max-length": 500,
                            "toolbar-items": {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.matter,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "matter", $$v)
                            },
                            expression: "formData.matter"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Descripción *" } },
                      [
                        _c("editor-text", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "description",
                          attrs: {
                            danger: _vm.errors.has(
                              "custom-document.description"
                            ),
                            "danger-text": _vm.errors.first(
                              "custom-document.description"
                            ),
                            "data-cy": "description",
                            "data-vv-as": "descripción",
                            "max-length": _vm.maxLengthDescription,
                            name: "description",
                            "toolbar-items": {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.description,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "description", $$v)
                            },
                            expression: "formData.description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-6 mt-2" },
                  [
                    _vm._v(" Visadores del proceso "),
                    _vm._m(0),
                    _c("list-user", {
                      ref: "visators",
                      staticClass: "w-100",
                      attrs: {
                        "is-multiple": "",
                        autocomplete: "",
                        "data-cy": "visators",
                        "data-vv-as": "visadores",
                        name: "visators",
                        label: "",
                        placeholder: "Selecciona los visadores",
                        danger: _vm.visatorsError !== "",
                        "danger-text": _vm.visatorsError
                      },
                      on: { "full-user": _vm.setInitials }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-6 mt-2" },
                  [
                    _vm._v(" Distribución interna "),
                    _c(
                      "v-select",
                      {
                        attrs: {
                          options: _vm.directions,
                          name: "directions",
                          label: "label",
                          "data-cy": "directions",
                          placeholder: "Selecciona la/s direccion/es",
                          multiple: ""
                        },
                        on: { input: _vm.searchUnits },
                        model: {
                          value: _vm.formData.directions,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "directions", $$v)
                          },
                          expression: "formData.directions"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(" no hay direcciones ")
                        ])
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c("b-form-checkbox", {
                          staticClass: "d-inline-block",
                          attrs: {
                            disabled: !_vm.directions.length,
                            "data-cy": "select-all"
                          },
                          on: {
                            change: function($event) {
                              return _vm.selectDirections(
                                _vm.selectAllDirections
                              )
                            }
                          },
                          model: {
                            value: _vm.selectAllDirections,
                            callback: function($$v) {
                              _vm.selectAllDirections = $$v
                            },
                            expression: "selectAllDirections"
                          }
                        }),
                        _vm._v(" Seleccionar todas ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.formData.directions.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-6 mt-2" },
                      [
                        _vm._v(" Unidad "),
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.units,
                              name: "units",
                              label: "label",
                              "data-cy": "units",
                              placeholder: "Selecciona la/s unidad/es",
                              multiple: ""
                            },
                            model: {
                              value: _vm.formData.units,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "units", $$v)
                              },
                              expression: "formData.units"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(" no hay unidades ")
                            ])
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-2" },
                          [
                            _c("b-form-checkbox", {
                              staticClass: "d-inline-block",
                              attrs: {
                                disabled: !_vm.units.length,
                                "data-cy": "select-all"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectUnits(_vm.selectAllUnits)
                                }
                              },
                              model: {
                                value: _vm.selectAllUnits,
                                callback: function($$v) {
                                  _vm.selectAllUnits = $$v
                                },
                                expression: "selectAllUnits"
                              }
                            }),
                            _vm._v(" Seleccionar todas ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-md-12 mt-2" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Distribución externa" } },
                      [
                        _c("editor-text", {
                          ref: "externalDistribution",
                          attrs: {
                            danger: _vm.errors.has(
                              "custom-document.externalDistribution"
                            ),
                            "danger-text": _vm.errors.first(
                              "custom-document.externalDistribution"
                            ),
                            "data-cy": "externalDistribution",
                            "data-vv-as": "distribución externa",
                            "max-length": _vm.maxLengthMatter,
                            name: "externalDistribution",
                            "toolbar-items": {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.externalDistribution,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.formData,
                                "externalDistribution",
                                $$v
                              )
                            },
                            expression: "formData.externalDistribution"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row align-items-center mt-5" }, [
                    _vm._m(1),
                    _c(
                      "div",
                      { staticClass: "col-md-3 align-items-end" },
                      [
                        _c("UploadFile", {
                          attrs: {
                            permission: "*",
                            accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                            text: "Seleccionar documentos",
                            "upload-to": "ed",
                            "button-class": {
                              "btn-block": true,
                              "mb-5": _vm.errors.has("custom-document.fileName")
                            },
                            "container-class": "w-100"
                          },
                          on: {
                            input: function($event) {
                              return _vm.addOthersFile()
                            }
                          },
                          model: {
                            value: _vm.fileOthers,
                            callback: function($$v) {
                              _vm.fileOthers = $$v
                            },
                            expression: "fileOthers"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "row align-items-center mt-1" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-md-3 align-items-end" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "ED060",
                                  expression: "'ED060'"
                                },
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal",
                                  value: "add-file-repository",
                                  expression: "'add-file-repository'"
                                }
                              ],
                              staticClass: "btn-icon mt-1",
                              attrs: {
                                variant: "secondary",
                                "data-cy": "from-repository"
                              }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "ServerIcon" }
                              }),
                              _vm._v(" Desde el repositorio ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.formData.attachments, function(file) {
                        return _c(
                          "div",
                          { key: file.id, staticClass: "col-2" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column align-items-center"
                              },
                              [
                                _c("vs-icon", {
                                  attrs: {
                                    icon: "description",
                                    size: "25px",
                                    color: "primary"
                                  }
                                }),
                                _c(
                                  "b",
                                  {
                                    staticClass:
                                      "text-truncate w-100 text-center"
                                  },
                                  [_vm._v(_vm._s(file.name))]
                                ),
                                _c("vs-button", {
                                  attrs: {
                                    color: "danger",
                                    type: "flat",
                                    icon: "clear"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeOthersFile(file.id)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  !!_vm.error.messageOthers
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger\n        vs-input--text-validation-span v-enter-to text-left"
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(" " + _vm._s(_vm.error.messageOthers) + " ")
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c(
                    "vs-button",
                    {
                      staticClass: "mt-5 mr-5",
                      attrs: {
                        "data-cy": "cancel",
                        color: "primary",
                        disabled: _vm.saving
                      },
                      on: {
                        click: function($event) {
                          return _vm.back()
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "vs-button",
                    {
                      staticClass: "mt-5 mr-5",
                      attrs: {
                        "data-cy": "preview",
                        color: "warning",
                        disabled: _vm.saving
                      },
                      on: { click: _vm.preview }
                    },
                    [
                      _vm._v(" Previsualizar "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.saving,
                            expression: "saving"
                          }
                        ],
                        staticClass:
                          "spinner-border spinner-border-sm text-primary"
                      })
                    ]
                  ),
                  _c(
                    "vs-button",
                    {
                      staticClass: "mt-5 mr-5",
                      attrs: {
                        "data-cy": "save",
                        color: "success",
                        disabled: _vm.saving
                      },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _vm._v(" Crear "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.saving,
                            expression: "saving"
                          }
                        ],
                        staticClass:
                          "spinner-border spinner-border-sm text-primary"
                      })
                    ]
                  )
                ],
                1
              ),
              _c("repository-selector", {
                attrs: {
                  "modal-id": "add-file-repository",
                  "add-file": _vm.addFileRepo,
                  files: _vm.formData.attachments,
                  "remove-file": _vm.removeOthersFile
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-danger" }, [_c("b", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }